import { reduxForm } from 'redux-form';

import EditAppForm from './EditAppForm';
import { validate } from '../../../home/models/EditAppForm';
export const FORM_ID = 'EditAppForm';

export default reduxForm({
  form: FORM_ID,
  validate: validate,
})(EditAppForm);
